// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"96":"33ea501b","453":"b545dd45"}[chunkId] + ".chunk.js";
};